import styled from 'styled-components'
import { Popup, Modal } from 'semantic-ui-react'
import { ModalWrapper as OriginalModalWrapper } from '@/components/Modal/style'

export const ModalWrapper = styled(Modal)`
    &.ui.modal {
        width: 700px;
        font-size: 0.85rem;
        border-radius: .18181818rem;

        @media (max-width: 767px) {
            width: 100%;

            &>.header{
                padding-right: 1rem !important;
            }
        }

        &>*:last-of-type {
            overflow: hidden;
            border-radius: inherit;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }

        &>.header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1em;
            border-bottom: 1px solid rgba(34, 36, 38, .15);
            font-size: inherit;

            &>.ui.header {
                margin-bottom: 0;
            }
        }

        & .ui.progress {
            margin: 1em 0;
        }

        &>.content {
            overflow-x: hidden;
            padding: 1em 1.5em;

            .label {
                display: block;
                margin-bottom: 10px;
            }
        }

        & {
            .answers-enter {
                opacity: 0;
                transform: translateX(50%);
                &.revert {
                    transform: translateX(-50%);
                }
            }
            .answers-enter-active,
            .answers-enter-active.revert {
                opacity: 1;
                transform: translateX(0);
                transition: opacity 300ms, transform 300ms;
            }
            .answers-exit {
                opacity: 1;
            }
            .answers-exit-active {
                opacity: 0;
                transform: translateX(-50%);
                transition: opacity 300ms, transform 300ms;
                &.revert {
                    transform: translateX(50%);
                }
            }
        }
    }
`
type ThemedTextProps = {
    $color?: string
}

export const ThemedLink = styled.a<ThemedTextProps>`
    color: ${({ $color }) => $color};
    font-weight: bold;
    font-style: italic;
`

export const ThemedText = styled.span<ThemedTextProps>`
    color: ${({ $color }) => $color};
    `

export const AnyQuestions = styled(ThemedText)`
    margin-right: .5em;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-offset: 4px;
    cursor: pointer;
    line-height: 1.2em;
`

export const CustomPopup = styled(Popup)`
    &.ui.popup {
        .ui.grid .row:first-child {
            padding-bottom: .5rem;
        }
        .ui.grid .row:last-child {
            padding-top: .5rem;
        }
        .description {
            font-size: .85em;
            color: rgba(0, 0, 0, .7);
        }
        @media (max-width: 767px) {
            .ui.grid .row {
                flex-direction: column;
                .column {
                    width: 100% !important;
                }
            } 
        }
    }
`

export const ProjectImage = styled.img`
    &&& {
        margin-right: 1em;
        width: 60px;
        height: 60px;
    }
` 

export const DoubleIcon = styled.div`
    div:first-of-type {
        transform: translate(-10px, 0) scale(.85);
    }
    div:last-of-type {
        transform: translate(10px, -20px) scale(.85);
    }
    div:hover {
        z-index: 1;
    }
`

export const LastPageButtons = styled.div`
    @media (max-width: 767px) {
        display: flex;
        margin-top: 2.5em;
        align-items: center;
        justify-content: end;
    }
    
    @media (max-width: 350px) {
        display: block;

        .ui.button {
            margin-top: .25em;
        }
    }
`